export default __webpack_public_path__ + "static/media/Tooth.6ead9727.svg";